// src/pages/CreateInvoice.jsx
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useGetAllBranchesQuery } from "../toolkitServices/branchApi";
import { useGetAllCategoriesQuery } from "../toolkitServices/categoryApi";
import { useGetAllProductsQuery } from "../toolkitServices/productApi";
import { useGetAllDesignsQuery } from "../toolkitServices/designApi";
import { useGetAllPuritiesQuery } from "../toolkitServices/purityApi";
import { useGetAllStonesQuery } from "../toolkitServices/stoneApi";
import { useGetAllDiamondsQuery } from "../toolkitServices/diamondApi";
import { useGetDiamondSievesQuery } from "../toolkitServices/diamondSieveApi";
import { useGetDiamondSizesQuery } from "../toolkitServices/diamondSizeApi";
import { useGetCountersQuery } from "../toolkitServices/counterApi";

import { setCategoryList } from "../slices/categorySlice";
import { setProductList } from "../slices/productSlice";
import { setDesignList } from "../slices/designSlice";
import { setPurityList } from "../slices/puritySlice";
import { setBranchList } from "../slices/branchSlice";
import { setStoneList } from "../slices/stoneSlice";
import { setDiamondList } from "../slices/diamondSlice";
import { setDiamondSieveList } from "../slices/diamondSieveSlice";
import { setDiamondSizeList } from "../slices/diamondSizeSlice";
import { setCounterList } from "../slices/counterSlice";

import InvoiceForm from "../components/NewInvoice/InvoiceForm";
import { useGetLatestRatesQuery } from "../toolkitServices/rateApi";
import { setLastestRateList } from "../slices/latestRateSlice";

const CreateInvoice = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: branches } = useGetAllBranchesQuery();
  const { data: categories } = useGetAllCategoriesQuery({ page: 1, limit: 1000, search: "" });
  const { data: products }   = useGetAllProductsQuery({ page: 1, limit: 2000, search: "" });
  const { data: designs }    = useGetAllDesignsQuery({ page: 1, limit: 2000, search: "" });
  const { data: purities }   = useGetAllPuritiesQuery({ page: 1, limit: 1000, search: "" });
  const { data: stones }     = useGetAllStonesQuery({ page: 1, limit: 2000, search: "" });
  const { data: diamonds }   = useGetAllDiamondsQuery({ page: 1, limit: 2000, search: "" });
  const { data: diamondSieves } = useGetDiamondSievesQuery({ page: 1, limit: 100 });
  const { data: diamondSizes }  = useGetDiamondSizesQuery({ page: 1, limit: 100 });
  const { data: counters }   = useGetCountersQuery({ page: 1, limit: 2000 });
  const { data:latestRates } = useGetLatestRatesQuery();

  useEffect(() => {
    if (categories?.data?.length) dispatch(setCategoryList(categories.data));
    if (products?.data?.length)   dispatch(setProductList(products.data));
    if (designs?.data?.length)    dispatch(setDesignList(designs.data));
    if (purities?.data?.length)   dispatch(setPurityList(purities.data));
    if (branches?.data?.length)   dispatch(setBranchList(branches.data));
    if (stones?.data?.length)     dispatch(setStoneList(stones.data));
    if (diamonds?.data?.length)   dispatch(setDiamondList(diamonds.data));
    if (diamondSieves?.data?.length) dispatch(setDiamondSieveList(diamondSieves.data));
    if (diamondSizes?.data?.length)  dispatch(setDiamondSizeList(diamondSizes.data));
    if (counters?.data?.length)   dispatch(setCounterList(counters.data));
    if (latestRates?.data?.length)   dispatch(setLastestRateList(latestRates.data));
  }, [categories?.data, products?.data, designs?.data, purities?.data, branches?.data, stones?.data, diamonds?.data, diamondSieves?.data, diamondSizes?.data, counters?.data,latestRates?.data, dispatch]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "Backspace") {
        e.preventDefault();
        navigate(-1);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [navigate]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="max-w-8xl mx-auto rounded-xl relative max-h-[90vh] overflow-y-auto hide-scrollbar-inv-main"
    >
      <InvoiceForm />
    </motion.div>
  );
};

export default CreateInvoice;
